import { Injectable } from '@angular/core';
import {catchError, delay, Observable, of, tap} from "rxjs";
import {environment} from "../../environments/environment";
import {Store} from "../model/store";
import {HttpClient} from "@angular/common/http";
import {handleError} from "./handle-error";

@Injectable({
  providedIn: 'root'
})
export class StoreService {
  baseUrl = environment.baseUrl + '/mercury/v1';
  cachedStoreId: string = '';
  storeById: Store | null = null;
  storeGMTDate!: string;
  storeGMTTime!: string;

  constructor(
    private http: HttpClient
  ) { }

  getStoreById(id: string): Observable<Store | null> {
    if (this.cachedStoreId == id && this.storeById != null) {
      this.calculateDateTimeOfTimeZone(this.storeById.zoneId);
      return of(this.storeById).pipe(
        delay(1)
      )
    }
    return this.fetchStoreById(id)
  }

  fetchStoreById(id: string): Observable<Store | null> {
    return this.http
      .get<Store>(this.baseUrl + `/stores/${id}`)
      .pipe(
        tap((d) => {
          this.calculateDateTimeOfTimeZone(d.zoneId);
          this.cachedStoreId = id;
          this.storeById = d
          console.log('fetchStoreById', d);
        }),
        catchError(handleError<Store | null>('fetchStoreById'))
      );
  }

  private calculateDateTimeOfTimeZone(timeZone: string): void {
    const options: any = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZone: timeZone,
      timeZoneName: 'short'
    };
    const storeDate = new Intl.DateTimeFormat('en-GB', options).formatToParts(new Date());
    const dateParts: any = {};
    storeDate.forEach(part => {
      dateParts[part.type] = part.value;
    });
    this.storeGMTDate = `${dateParts['year']}-${dateParts['month']}-${dateParts['day']}`;
    this.storeGMTTime = `${dateParts['hour']}:${dateParts['minute']}`;

    setTimeout(() => {
      this.calculateDateTimeOfTimeZone(timeZone)
      console.log('calculateDateTimeOfTimeZone', timeZone, this.storeGMTDate, this.storeGMTTime)
    }, 60 * 1000)
  }
}
